<div class="d-flex justify-content-center my-5" *ngIf="show">
    <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">{{ "LOADING" | translate | titlecase }}</span>
    </div>
</div>